import { Theme } from '@mui/material';

export const getInputBorderStyle = ({
  isError,
  theme,
  hideBorder,
}: {
  isError?: boolean;
  theme: Theme;
  hideBorder?: boolean;
}) => ({
  borderWidth: hideBorder ? 0 : isError ? '1px' : '0.5px',
  borderColor: isError ? 'red' : theme.palette.lightOutlineGrey.main,
});
